import React from "react"
import TopVenuesSelector from "./TopVenuesSelector"
import TopVenuesDisplay from "./TopVenuesDisplay"

export default class Top100Venues extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedGroup: this.initialGroup()
    }
  }

  initialGroup = () => {
    const { initialGroup, venueGroups } = this.props
    return venueGroups.hasOwnProperty(initialGroup) ? initialGroup : Object.keys(venueGroups)[0]
  }

  handleSelection = selected => e => {
    if (this.props.history.replaceState) {
      e.preventDefault()
      this.props.history.replaceState({}, "", e.target.href)
    }

    this.setState({ selectedGroup: selected })
  }

  render() {
    return (
      <div>
        <TopVenuesSelector
          venueGroups={this.props.venueGroups}
          selectedGroup={this.state.selectedGroup}
          handleSelection={this.handleSelection}
        />
        <TopVenuesDisplay
          venues={this.props.venueGroups[this.state.selectedGroup].venues}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/top_venues/Top100Venues.jsx